import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import _groupBy from 'lodash/groupBy';
import _keys from 'lodash/keys';

class ChoiceWidget extends Component {
  state = {
    isOpen: false
  };

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.click = this.click.bind(this);
    this.getDataSource = this.getDataSource.bind(this);
    this.renderSingleDropdown = this.renderSingleDropdown.bind(this);
    this.renderGroupedDropdown = this.renderGroupedDropdown.bind(this);
    this.renderPlaceholder = this.renderPlaceholder.bind(this);
    this.renderLabel = this.renderLabel.bind(this);
    this.compare = this.compare.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }

  click(choice) {
    return () => {
      this.props.onSelect(choice);
    }
  }

  compare(choice, data) {
    const defaultComparator = (choice) => {
      return data && (choice.value === data.value);
    };

    const comparator = this.props.comparator || defaultComparator;

    return comparator(choice, data);
  }

  componentDidMount() {
    //window.FONTPLUS.reload();
  }

  renderGroupedDropdown(groupBy) {
    const choiceRenderer = this.props.renderChoice || ((choice) => {
      return choice.label;
    });

    const headerRenderer = this.props.renderHeader || ((key) => {
      return key;
    });

    const dataSource = _groupBy(this.props.choices, (value) => value[groupBy]);
    const keys = _keys(dataSource);

    return (
      <DropdownMenu>
        {keys.map((key) => {
          return (
            <React.Fragment key={key}>
              <DropdownItem header key={key}>
                {headerRenderer(key)}
              </DropdownItem>
              {dataSource[key].map((choice, i) => {
                return (
                  <DropdownItem key={i} onClick={this.click(choice)} active={choice.value === this.props.data.value}>
                    {choiceRenderer(choice)}
                  </DropdownItem>
                );
              })}
            </React.Fragment>
          );
        })}
      </DropdownMenu>
    );
  }

  renderSingleDropdown() {
    const choiceRenderer = this.props.renderChoice || ((choice) => {
      return choice.label;
    });

    return (
      <DropdownMenu>
        {this.renderPlaceholder()}
        {this.props.choices.map((choice, i) => {
          //console.log(choice, this.props.data);
          return (
            <DropdownItem key={i} onClick={this.click(choice)} active={this.compare(choice, this.props.data)}>
              {choiceRenderer(choice)}
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    );
  }

  renderPlaceholder() {
    if (this.props.placeholder) {
      return (
        <DropdownItem key="choice-placeholder" onClick={this.click(null)} active={!this.props.data}>
          {this.props.placeholder.renderChoice()}
        </DropdownItem>
      );
    }
  }

  renderLabel() {
    const labelRenderer = this.props.renderLabel || ((data) => {
      return data.label;
    });

    if (!this.props.data && this.props.placeholder) {
      return this.props.placeholder.renderLabel();
    }

    return labelRenderer(this.props.data);
  }

  render() {
    // const labelRenderer = this.props.renderLabel || ((data) => {
    //   return data.label;
    // });

    const groupBy = this.props.groupBy || false;

    return (
      <Dropdown isOpen={this.state.isOpen} toggle={this.toggle}>
        <DropdownToggle caret>
          {/*{labelRenderer(this.props.data)}*/}
          {this.renderLabel()}
        </DropdownToggle>
        { groupBy ? this.renderGroupedDropdown(groupBy) : this.renderSingleDropdown() }
      </Dropdown>
    );
  }

  getDataSource() {
    const groupBy = this.props.groupBy || false;

    if (groupBy) {
      return _groupBy(this.props.choices, (value) => value[groupBy]);
    } else {
      return this.props.choices;
    }
  }
}

export default ChoiceWidget;


// WEBPACK FOOTER //
// ./src/components/ChoiceWidget.js